import { render, staticRenderFns } from "./MultiProductDashboard.vue?vue&type=template&id=fae6952a&scoped=true&"
import script from "./MultiProductDashboard.vue?vue&type=script&lang=js&"
export * from "./MultiProductDashboard.vue?vue&type=script&lang=js&"
import style0 from "./MultiProductDashboard.vue?vue&type=style&index=0&id=fae6952a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae6952a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VDivider,VRow,VSkeletonLoader})
